import { css } from '@emotion/core';
export const $copyTextContainer = () => css`
  margin-bottom: 10px;
  `;
export const $copyContainer = () => css`
    max-width: 250px;
  `;
